import { render, staticRenderFns } from "./FinishGoodQualityInspectNgInboxInput.vue?vue&type=template&id=70cea62e&scoped=true&"
import script from "./FinishGoodQualityInspectNgInboxInput.vue?vue&type=script&lang=js&"
export * from "./FinishGoodQualityInspectNgInboxInput.vue?vue&type=script&lang=js&"
import style0 from "./FinishGoodQualityInspectNgInboxInput.vue?vue&type=style&index=0&id=70cea62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cea62e",
  null
  
)

export default component.exports